var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 22C8.75099 22 8.50199 21.907 8.30799 21.722L1.18699 14.894C-0.388008 13.32 -0.388008 10.782 1.17199 9.22201L8.30299 2.28301C8.69899 1.89801 9.33199 1.90601 9.71699 2.30301C10.102 2.69901 10.093 3.33201 9.69699 3.71701L2.57599 10.646C1.80599 11.416 1.80599 12.686 2.58599 13.465L9.69199 20.278C10.091 20.66 10.104 21.294 9.72199 21.692C9.52599 21.896 9.26299 22 8.99999 22ZM15.698 21.716L22.81 14.776C24.369 13.216 24.369 10.678 22.796 9.10501L15.693 2.27901C15.295 1.89701 14.662 1.91001 14.279 2.30701C13.897 2.70501 13.909 3.33801 14.307 3.72101L21.396 10.532C22.175 11.312 22.175 12.581 21.405 13.352L14.301 20.284C13.905 20.67 13.898 21.303 14.283 21.698C14.479 21.899 14.739 22 14.999 22C15.251 22 15.503 21.905 15.697 21.716H15.698Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSimple);
export default __webpack_public_path__ + "static/media/code-simple.43d1bfa3300b2cbfbdca1814e2bad0c9.svg";
export { ForwardRef as ReactComponent };